/**
 * MTL Required Color/Finish Enforcement — RETIRED, GOLD IS PRESELECTED (2026-08-11)
 * ---------------------------------------------------------------------------------
 * The original module (2026-04-26) existed to stop customers "silently getting
 * whatever the default variant is (usually Gold)" by locking Add to Cart with
 * "Choose your finish first" until a swatch was explicitly clicked.
 *
 * That trade was reversed on 2026-08-11 (owner): the lock meant EVERY visitor,
 * including every Pinterest click, landed on a PDP they could not buy from. Gold
 * is now an explicit, visible default rather than a silent one - the gold swatch
 * renders selected, the finish label reads ": GOLD", the gold image shows, and
 * the customer can change it in one tap.
 *
 * This file no longer locks or relabels the Add to Cart button. It still emits
 * `mtl:color-picked` + body[data-mtl-color-picked] on the first swatch click so
 * any downstream listener keeps working unchanged.
 *
 * Reversible: restore from the dated snapshot in Ops/snapshots/.
 */
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  function init() {
    const onPDP = document.querySelector(
      'product-form, .product__media, [data-mtl="atc-btn"], product-page'
    );
    if (!onPDP) return;

    const swatches = Array.from(document.querySelectorAll(
      '[data-mtl-swatch], ' +
      'button.swatch, swatch-input, ' +
      'fieldset[data-option-name="Color"] input[type="radio"], ' +
      'fieldset[data-option-name="Color"] label, ' +
      '[data-option-name="Color"] button, ' +
      'input[type="radio"][name*="Color" i]'
    ));
    if (swatches.length < 2) return;

    let picked = false;
    function markPicked() {
      if (picked) return;
      picked = true;
      try {
        document.body.dataset.mtlColorPicked = 'true';
        document.dispatchEvent(new CustomEvent('mtl:color-picked', { bubbles: true }));
      } catch (_) {}
    }

    swatches.forEach(s => {
      s.addEventListener('click', markPicked, { passive: true });
      s.addEventListener('change', markPicked, { passive: true });
    });

    document.addEventListener('click', function(e) {
      const tgt = e.target;
      if (!tgt || !tgt.closest) return;
      if (
        tgt.closest('[data-mtl-swatch]') ||
        tgt.closest('button.swatch') ||
        tgt.closest('swatch-input') ||
        tgt.closest('fieldset[data-option-name="Color"]') ||
        tgt.closest('[data-option-name="Color"]')
      ) markPicked();
    }, { passive: true, capture: true });
  }
})();
